import React, { useEffect, useState } from 'react';
import Style from './MainBlogPage.module.css';
import { CardsBlogPortalOneOFThree } from '../../comps/cards/Cards';
import StaffPicks from '../../comps/StaffPicks';
import basedGetUrlRequestLogedIn from '../../../../util/apiRequests/basedGetUrlRequestLogedIn';
import SkeletonLoadingFirst3 from '../../comps/cards/SkeletonLoadingFirst3';
import { SkeletonStaffPicksCardImage } from '../../comps/cards/StaffPicksCardImage';
import { LayoutSideNavigation, Page } from '../../../../components';
import TopbarContainer from '../../../TopbarContainer/TopbarContainer';
import BlogAllNewsMenu from '../../comps/BlogAllNewsMenu';
import { useHistory, useLocation } from 'react-router-dom';
import FooterContainer from '../../../FooterContainer/FooterContainer';
import LargText from '../../../../components/text/LargText';
import { PiList } from 'react-icons/pi';
import AllBlogsPage from '../../comps/AllBlogsPage';

const MainBlogPage = () => {
  const [reqWasMaded, setReqWasMaded] = useState(false);
  const [stories, setStories] = useState([]);
  const [topReadStories, setTopReadStories] = useState([]);
  const [isActive, setIsActive] = useState(false);
  const handleTogleMenu = () => {
    setIsActive(!isActive);
  };

  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);
  const category = queryParams.get('category');
  const id = queryParams.get('id');

  useEffect(() => {
    setReqWasMaded(false);

    basedGetUrlRequestLogedIn(
      `/api/blog-story-by-id/search?${category ? 'category=' + category : ''}${
        id ? '&id=' + id : ''
      }`
    )
      .then(res => {
        if (res.topReadStories) setTopReadStories(res.topReadStories);
        if (res) setReqWasMaded(true);
        if (res.story) {
        } else if (res.stories) {
          setStories(res.stories);
          setIsPage(false);
        }
      })
      .catch(() => {
        setReqWasMaded(true);
      });
  }, [search]);

  return (
    <Page title={'Aloka | Blog'}>
      <LayoutSideNavigation
        topbar={<TopbarContainer currentPage="blog" />}
        sideNav={
          <div className={Style.container}>
            <BlogAllNewsMenu isActive={isActive} handleTogleMenu={handleTogleMenu} />
            <div className={Style.container_BlogPortal}>
              <div className={Style.top_container_title_top}>
                <div onClick={handleTogleMenu} className={Style.close_button}>
                  <PiList />
                </div>
                <LargText text={'Blog'} />
              </div>
              <>
                {category === 'all-articles' ? (
                  <>
                    <div className={Style.blog_portal_first_3_card_container}>
                      {stories.slice(0, 5).map(cardData => (
                        <CardsBlogPortalOneOFThree key={cardData.title} cardData={cardData} />
                      ))}
                      {!reqWasMaded && <SkeletonLoadingFirst3 elementNumber={6} />}
                      {topReadStories.length >= 1 && (
                        <div className={`${Style.container_to_add_title} ${Style.StaffPicks}`}>
                          <StaffPicks
                            textTitle={'Lo más leído'}
                            blogData={topReadStories.slice(0, 2)}
                          />
                        </div>
                      )}
                    </div>
                    {!reqWasMaded && <SkeletonStaffPicksCardImage />}
                    {stories.length >= 6 && (
                      <AllBlogsPage blogData={stories.slice(5, stories.length)} />
                    )}
                  </>
                ) : (
                  <>
                    <div className={Style.blog_portal_first_3_card_container}>
                      {stories.slice(0, 3).map(cardData => (
                        <CardsBlogPortalOneOFThree key={cardData.title} cardData={cardData} />
                      ))}
                      {!reqWasMaded && <SkeletonLoadingFirst3 elementNumber={3} />}
                    </div>
                    {!reqWasMaded && <SkeletonStaffPicksCardImage />}
                    {stories.length >= 1 && (
                      <AllBlogsPage
                        isStaffPicks={true}
                        staffPicksData={topReadStories}
                        blogData={stories.slice(3, stories.length)}
                      />
                    )}
                  </>
                )}
              </>
            </div>
          </div>
        }
        footer={<FooterContainer />}
      ></LayoutSideNavigation>
    </Page>
  );
};

export default MainBlogPage;
